import axios from "axios";

// IP never changes during a session — cache the result permanently.
// Concurrent callers share one in-flight promise; subsequent callers get the cached value instantly.
let _cached = null;
let _promise = null;

const getIP = () => {
    if (_cached) return Promise.resolve(_cached);
    if (_promise) return _promise;
    _promise = axios.get('https://api.ipify.org?format=json')
        .then(res => {
            _cached = res;
            _promise = null;
            return res;
        })
        .catch(err => {
            _promise = null;
            throw err;
        });
    return _promise;
};

export default getIP;